<template>
  <div class="flex w-fit max-w-48 items-center space-x-2">
    <div v-if="iconData" class="h-4 w-4">
      <icon-base
        v-tooltip="
          $t(
            `ORGANIZATION.COMMUNICATION_TEMPLATES.${iconData.icon.toUpperCase()}_TOOLTIP`
          )
        "
        v-bind="iconData"
        :data-cy="`icon-${iconData.icon}`"
        class="focus:outline-none"
      />
    </div>
    <span
      v-tooltip="model.name"
      class="line-clamp-2 text-headline"
      @click="showTemplate"
    >
      {{ model.name }}
    </span>
  </div>
</template>
<script setup lang="ts">
import { EmailTemplateVisibility } from "@/enums/emailCustomization";
import { UTIL_COLORS } from "@/helpers/constants";
import type { EmailTemplate } from "@/models/clients";
import { ROUTE_EMAIL_TEMPLATES_EDIT } from "@/router/routes";
import { computed } from "vue";
import { useRouter } from "vue-router";

const props = defineProps<{
  model: EmailTemplate;
  type: "email" | "sms";
}>();

const routeNameMap = {
  email: ROUTE_EMAIL_TEMPLATES_EDIT
};

const router = useRouter();

const iconData = computed(() => {
  if (props.model.visibility === EmailTemplateVisibility.Global) {
    return {
      icon: "globe",
      iconColor: UTIL_COLORS.PRIMARY
    };
  }

  if (props.model.visibility === EmailTemplateVisibility.Organizational) {
    return {
      icon: "organization",
      iconColor: UTIL_COLORS.PRIMARY
    };
  }

  return null;
});

const showTemplate = async () => {
  if (!props.model?.id || props.type !== "email") {
    return;
  }
  const pushPayload = {
    name: routeNameMap[props.type],
    params: {
      templateId: props.model.id
    }
  };

  await router.push(pushPayload);
};
</script>
